import {
  ToggleButtonClasses,
  generateUtilityClasses,
  toggleButtonClasses as muiToggleButtonClasses,
} from '@mui/material';

export interface UnifyToggleButtonClasses {
  startIcon: string;
  hasChildren: string;
}

const unifyToggleButtonClasses: UnifyToggleButtonClasses =
  generateUtilityClasses('MuiToggleButton', ['startIcon', 'hasChildren']);

export const toggleButtonClasses: ToggleButtonClasses = {
  ...muiToggleButtonClasses,
  ...unifyToggleButtonClasses,
};

export default toggleButtonClasses;
